export { customerVendorRoute } from './route'
